import React from 'react';
import { Lock, RotateCcw, Zap, UserX } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function FinalCTA() {
  return <section className="py-16 md:py-20 text-center bg-[radial-gradient(ellipse_at_center_top,#1a0e00_0%,#0a0a0a_60%)] border-t border-[rgba(201,151,43,.2)]" data-id="element-132">
      <div className="container" data-id="element-133">
        <div className="section-label justify-center" data-id="element-134">La decisión es tuya</div>
        <h2 className="font-playfair text-[clamp(1.9rem,4vw,3.1rem)] font-black text-blanco max-w-[680px] mx-auto mb-4 leading-[1.15]" data-id="element-135">
          El conocimiento que cambia
          <br data-id="element-136" />
          cómo te relacionas con el mundo.
        </h2>
        <p className="text-gris-texto max-w-[460px] mx-auto mb-9 text-[.95rem]" data-id="element-137">
          +4.000 personas ya tienen esta ventaja. Hoy puedes ser parte de ellas
          — con garantía total y riesgo cero.
        </p>

        <div className="flex justify-center mb-5" data-id="element-138">
          <span className="bg-[rgba(192,57,43,.15)] border border-[rgba(192,57,43,.3)] text-rojo-vivo text-[11px] font-bold tracking-[.06em] py-1.5 px-3 rounded-full" data-id="element-139">
            🚨 Últimos cupos
          </span>
        </div>

        <a href="https://pay.hotmart.com/O105395702C?checkoutMode=10" onClick={trackAddToCart} className="btn-primary animate-shimmer text-[14px] p-[18px_48px] inline-flex items-center justify-center" data-id="element-140">
          Quiero acceder a Código Oscuro — $6.36 USD
        </a>

        <div className="flex flex-wrap justify-center gap-3.5 text-xs text-gris-texto mt-[22px]" data-id="element-141">
          <span className="flex items-center gap-1.5" data-id="element-142">
            <Lock className="w-3.5 h-3.5 text-dorado" data-id="element-143" /> Pago seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-144">
            <RotateCcw className="w-3.5 h-3.5 text-dorado" data-id="element-145" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-146">
            <Zap className="w-3.5 h-3.5 text-dorado" data-id="element-147" /> Acceso inmediato
          </span>
          <span className="flex items-center gap-1.5" data-id="element-148">
            <UserX className="w-3.5 h-3.5 text-dorado" data-id="element-149" /> Privacidad protegida
          </span>
        </div>

        <div className="flex items-center justify-center gap-2.5 mt-[18px] flex-wrap" data-id="element-150">
          <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#1a73e8]" data-id="element-151">
            Visa
          </div>
          <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#eb001b]" data-id="element-152">
            MC
          </div>
          <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#003087]" data-id="element-153">
            PayPal
          </div>
          <div className="bg-[#1c1c1c] border border-[rgba(255,255,255,.1)] rounded px-2.5 py-1 text-[10px] font-bold text-[rgba(255,255,255,.5)] tracking-[.05em] flex items-center gap-1 text-[#007bc1]" data-id="element-154">
            Amex
          </div>
        </div>
      </div>
    </section>;
}